import { withWorkspaceV2Aliases } from 'dashboard/helper/workspaceV2';
import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import helpCenterEmbedRoutes from './helpcenter/helpCenterEmbed.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import emailSequencesRoutes from './emailSequences/emailSequences.routes';
import whatsappGroupsRoutes from './whatsappGroups/whatsappGroups.routes';
import instagramAutomationRoutes from './instagramAutomation/instagramAutomation.routes';
import facebookAutomationRoutes from './facebookAutomation/facebookAutomation.routes';
import voipCallsRoutes from './voipCalls/voipCalls.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as hubRoutes } from './hub/hub.routes';
import { routes as onboardingHelpRoutes } from './onboardingHelp/onboardingHelp.routes';
import { routes as releaseNotesRoutes } from './releaseNotes/releaseNotes.routes';
import { routes as aiCenterRoutes } from './aiCenter/aiCenter.routes';
import planosRoutes from './planos/planos.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import DashboardAppWrapper from './dashboard-apps/DashboardAppWrapper.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingVisor from './onboardingVisor/Index.vue';

const KanbanView = () => import('./kanban/KanbanView.vue');
const TasksApp = () => import('./tasks/TasksApp.vue');
const InternalChatView = () => import('./internal-chat/InternalChatView.vue');
const AutomationLogsPage = () =>
  import('./automationLogs/AutomationLogsPage.vue');

// Endereço dentro da conta que não bate com nenhuma tela (link velho, rota
// removida). O guard do router leva para a Central com um aviso; o
// componente nunca chega a renderizar.
export const NOT_FOUND_ROUTE = 'not_found';

export default {
  routes: [
    {
      path: frontendURL('mcp/authorize'),
      name: 'mcp_authorize',
      component: () => import('./mcp/Authorize.vue'),
    },
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        {
          path: frontendURL(
            'accounts/:accountId/v2/propostas/:area(tarefas|agenda)'
          ),
          name: 'workspace_v2_proposals',
          component: () =>
            import(
              'dashboard/components-next/workspaceV2/WorkspaceV2Proposals.vue'
            ),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: frontendURL('accounts/:accountId/v2'),
          name: 'workspace_v2_entry',
          redirect: to => ({
            path: `/app/accounts/${to.params.accountId}/v2/hub`,
            query: to.query,
          }),
        },
        ...withWorkspaceV2Aliases([
          {
            path: frontendURL('accounts/:accountId/dashboard_apps/:id'),
            name: 'dashboard_apps_show',
            component: DashboardAppWrapper,
            meta: {
              permissions: ['administrator', 'agent'],
              icon: 'i-ri-apps-line',
              label: 'DASHBOARD_APPS',
            },
            props: true,
          },
          {
            path: frontendURL('accounts/:accountId/kanban'),
            name: 'kanban_board',
            component: KanbanView,
            meta: {
              permissions: [
                'administrator',
                'agent',
                'kanban_manage',
                'kanban_view',
              ],
              featureFlag: 'kanban_board',
            },
          },
          {
            path: frontendURL('accounts/:accountId/tasks'),
            name: 'tasks',
            component: TasksApp,
            meta: {
              permissions: ['administrator', 'agent', 'tasks_view'],
            },
          },
          {
            path: frontendURL('accounts/:accountId/automation-logs'),
            name: 'automation_logs',
            component: AutomationLogsPage,
            meta: {
              permissions: ['administrator', 'agent'],
            },
          },
          {
            path: frontendURL('accounts/:accountId/internal-chat'),
            name: 'internal_chat',
            component: InternalChatView,
            meta: {
              permissions: ['administrator', 'agent', 'team_chat_view'],
            },
          },
          ...captainRoutes,
          ...hubRoutes,
          ...onboardingHelpRoutes,
          ...releaseNotesRoutes,
          ...aiCenterRoutes,
          ...planosRoutes.routes,
          ...inboxRoutes,
          ...conversation.routes,
          ...settings.routes,
          ...contactRoutes,
          ...companyRoutes,
          ...searchRoutes,
          ...notificationRoutes,
          ...helpcenterRoutes.routes,
          ...helpCenterEmbedRoutes.routes,
          ...campaignsRoutes.routes,
          ...emailSequencesRoutes.routes,
          ...whatsappGroupsRoutes.routes,
          ...instagramAutomationRoutes.routes,
          ...facebookAutomationRoutes.routes,
          ...voipCallsRoutes.routes,
        ]),
        {
          path: frontendURL('accounts/:accountId/:pathMatch(.*)+'),
          name: NOT_FOUND_ROUTE,
          component: { render: () => null },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      // Onboarding Visor (D64). O prefixo onboarding_ faz o guard tratar como
      // tela de onboarding: quem já concluiu volta para a Central.
      path: frontendURL('accounts/:accountId/comecar'),
      name: 'onboarding_visor',
      meta: {
        permissions: ['administrator'],
      },
      component: OnboardingVisor,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
